import React from 'react';
import './Questions.sass';
import StandardButton from "../../../ui/Button/StandardButton";
const Questions = ({
  showQuestions,
  choices,
  title,
  body,
  formRef,
  showFeedback,
  showNextButton,
}) => {
  return (
    <div className={showQuestions ? 'questions' : 'hidden'}>
      {title ? <h2 className="title">{title}</h2> : ''}
      <hr />
      {body ? <p className="body">{body}</p> : ''}
      <form ref={formRef}>
        <ul>
          {choices
            ? choices.map((choice, index) => {
                const { label } = choice;
                return (
                  <li key={index}>
                    <label unselectable="on">
                      <input
                        id={'question_' + (index + 1)}
                        name={'question_' + (index + 1)}
                        type="checkbox"
                        value="true"
                      />
                      {label}
                    </label>
                  </li>
                );
              })
            : ''}
        </ul>
        {!showNextButton ? (
            <StandardButton data={"Submit"} callback={showFeedback} style={{
                "position":"absolute",
                "bottom":"-60px",
                "right":0,
                "margin":"auto"
            }}/>
        ) : (
          ''
        )}
      </form>
    </div>
  );
};

export default Questions;
